const config = {
    conversationlistUrl: 'https://chat.realgeeksai.com/conversationlist',
    conversationMetrics: 'https://chat.realgeeksai.com/conversations/metrics',
  };
  
export default config;
  